'use client';

import { useApiQuery } from '@shared/api-utils';

/**
 * Hook to fetch jackpots from the API
 * Hook manages refetching and caching of the jackpots data
 * @param api - The API endpoint to fetch the jackpots from
 * @param refreshInterval - The interval in milliseconds to refresh the jackpots
 * @returns The jackpots data, error and loading state
 */
function useFetchJackpots<T>(api: string, refreshInterval: number) {
  const { data, isLoading, error } = useApiQuery<T>(api, {
    queryOptions: {
      refetchInterval: refreshInterval,
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
  });

  return { data, error, isLoading };
}

export { useFetchJackpots };
